/* MIXINS */
import validatorMixins from '@mixins/validatorMixins';

export default {
  mixins: [validatorMixins],
  data() {
    return {
      listFormeJuridique: [],
      filterName: '',
      housekeeperAccommodations: [],
      housekeeperPrestations: [],
      partnerMissions: [],
    };
  },
  computed: {
    isLoadingFormeJuridique() {
      return this.listFormeJuridique === undefined;
    },
    enabledAccommodations() {
      return this.housekeeperAccommodations.filter((ha) => !ha.disabled);
    },
    selectedAccommodations() {
      return this.enabledAccommodations.filter((ha) => ha.isSelected);
    },
    selectedAccommodationIds() {
      return this.selectedAccommodations.map((ha) => ha.accommodationId);
    },
    housekeeperAccommodationsWithFilter() {
      return this.housekeeperAccommodations.filter((ha) =>
        ha.accommodationName.toLowerCase().includes(this.filterName.toLowerCase()),
      );
    },
  },
  methods: {
    toggleAccommodation(ha) {
      if (ha.disabled) return;
      ha.isSelected ^= true;
      if (ha.isSelected) {
        this.housekeeperPrestations.push({accommodationId: ha.accommodationId});
      } else {
        let index = this.housekeeperPrestations.map((el) => el.accommodationId).indexOf(ha.accommodationId);
        this.housekeeperPrestations.splice(index, 1);
      }
    },
    selectAllAccommodation() {
      for (let ha of this.enabledAccommodations) {
        ha.isSelected = true;
        this.housekeeperPrestations.push({accommodationId: ha.accommodationId});
      }
    },
    unselectAllAccommodation() {
      for (let ha of this.enabledAccommodations) {
        ha.isSelected = false;
        let index = this.housekeeperPrestations.map((el) => el.accommodationId).indexOf(ha.accommodationId);
        this.housekeeperPrestations.splice(index, 1);
      }
    },
    getHousekeeperPrestationIndex(ha) {
      return this.housekeeperPrestations.map((el) => el.accommodationId).indexOf(ha.accommodationId);
    },

    getPartnerMissionTypesForForm(accommodationId) {
      return this.partnerMissions.filter((el) => el.accommodationId === accommodationId);
    },

    isReceptionTypePhysical(ha) {
      return ha.receptionTypeCheckin === 'PHYSICAL' || ha.receptionTypeCheckout === 'PHYSICAL';
    },
  },
};
